import { styled, css } from '../../style';

const StyledDiv = styled('div')(
  ({ theme }) => css`
    .icon-wrapper {
      display: flex;
      flex-direction: row;
      align-self: center;
      align-items: center;
      justify-content: center;

      background: ${theme.colors.farmListBackground};
      border: 1px solid ${theme.colors.border};
      padding: 18px 6px;
      border-radius: 40px;
      width: 64px;
      height: 64px;

      > :first-child {
        margin-left: 0;
      }
    }

    .details-icon-wrapper {
      display: flex;
      flex-direction: row;
      align-self: center;
      align-items: center;
      padding: 18px 3px;

      > :first-child {
        margin-left: 0;
      }
    }

    .details-icon-image {
      margin-left: -10px;
      height: 64px;
      width: 64px;
      border: 1px solid #e3e3e5;
      border-radius: 64px;
    }
    .icon-image {
      margin-left: -10px;
      height: 30px;
      width: 30px;
    }
    .first {
      z-index: 1;
    }

    .single-icon-image {
      height: 48px;
      width: 48px;
    }
  `
);

export default StyledDiv;
